<template>
  <div>
    <van-popup v-model="show" position="center" :close-on-click-overlay="false" @close="change">
      <div class="yuyue_content">
        <div class="yuyue_content_title">
          <img src="@/assets/image/game/suss.png" mode="scaleToFill" />
          <span>预约成功</span>
        </div>
        <div class="yuyue_content_text">
          <div>预约成功！需要取消请点击</div> 
          <div @click="cancelYuyue" style="color: #333;margin-left: .45rem;">取消预约</div>
        </div>
        <!-- <div class="phonebox">
          <div class="phonebox_text">接收短信手机号：{{phone}}</div>
        </div> -->
        <single-button @know="close" text="知道了" width="10.9rem" height="1.7rem" color="#FFDB89"></single-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'UniMailiangYuyuePopup',

  props: {
    open: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      phone: '',
      show: false
    };
  },

  mounted() {
    
  },

  methods: {
    change() {
      this.$store.commit('popup/setisMobileCofirm', {
        yuyue: false,
      })
    },
    cancelYuyue() {
      this.$emit('func')
      this.close()
    },
    close() {
      this.show = false;
    }
  },

  watch: {
    open(val) {
      if (val) {
        this.show = true;
        this.phone = this.$store.state.popup.isMobileCofirm.phone
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup{
  border-radius: .5rem;
}
.yuyue_content {
  width: 15.5rem;
  height: 9.55rem;
  background: linear-gradient( 180deg, #FFF3D4 0%, #FFFFFF 40%);
  border-radius: .5rem .5rem .5rem .5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  .yuyue_content_title{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1.25rem;
    padding-bottom: 1.2rem;
    img{
      width: 1.07rem;
      height: 1.07rem;
      margin-right: .3rem;
    }
    span{
      font-weight: 700;
      font-size: 1rem;
    }
  }
  .yuyue_content_text{
    font-size: .7rem;
    color: #8E8E8E;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.38rem;
  }
  .phonebox{
    width: 12rem;
    height: 1.8rem;
    background: #F8F8F8;
    border-radius: .25rem .25rem .25rem .25rem;
    color: #333;
    font-size: .7rem;
    margin: 0 auto;
    margin-top: 1.15rem;
    margin-bottom: 1.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>